import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Layout } from '@cheetahdigital/console-kit-cx';
import { useState } from 'react';
import { useOrganizationContext } from '../../../contexts/OrganizationProvider.js';
import { useTranslation } from '../../../locales/i18n.js';
import Menu from '../../../shared/components/Menu/index.js';
import Modal from '../../../shared/components/Modal/index.js';
import '../../../node_modules/classnames/index.js';
import 'semantic-ui-react';
import Loading from '../../../shared/components/Loading/index.js';
import Label from '../../../shared/elements/Label/index.js';
import Headline from '../../../shared/elements/Headline/index.js';
import Input from '../../../shared/form/Input/index.js';
import Layout$1 from '../../../shared/layout/Layout/index.js';
import Row from '../../../shared/layout/Row/index.js';
import Column from '../../../shared/layout/Column/index.js';
import FlexColumns from '../../../shared/layout/FlexColumns/index.js';
import FlexColumn from '../../../shared/layout/FlexColumn/index.js';
import BusinessunitGroup from './BusinessunitGroup.js';
import styles from './index.module.scss.js';
import sortBy from '../../../node_modules/ramda/es/sortBy.js';
import pipe from '../../../node_modules/ramda/es/pipe.js';
import prop from '../../../node_modules/ramda/es/prop.js';
import toLower from '../../../node_modules/ramda/es/toLower.js';
import toPairs from '../../../node_modules/ramda/es/toPairs.js';
import fromPairs from '../../../node_modules/ramda/es/fromPairs.js';
import sortWith from '../../../node_modules/ramda/es/sortWith.js';
import descend from '../../../node_modules/ramda/es/descend.js';
import filter from '../../../node_modules/ramda/es/filter.js';
import flatten from '../../../node_modules/ramda/es/flatten.js';
import map from '../../../node_modules/ramda/es/map.js';
import values from '../../../node_modules/ramda/es/values.js';
import groupBy from '../../../node_modules/ramda/es/groupBy.js';

var ChangeBusinessUnitModal = function (_a) {
    var _b = _a.isActive, isActive = _b === void 0 ? false : _b, onClose = _a.onClose;
    var t = useTranslation()[0];
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var organizations = useOrganizationContext().organizations;
    var _d = useState(""), query = _d[0], setQuery = _d[1];
    var groupByOrganizationWithOrgName = function (organizationBUs) {
        return groupBy(function (organizationBU) { return String(organizationBU.orgName); }, organizationBUs);
    };
    var sortByName = sortBy(pipe(prop("buName"), toLower));
    var sortGroupByOrgName = pipe(toPairs, sortBy(prop(0)), fromPairs);
    var sortByIsDefault = sortWith([
        descend(prop("isDefault"))
    ]);
    var filterByQuery = function (businessUnit) {
        var _a, _b, _c, _d;
        if (query) {
            return (((_b = (_a = businessUnit.buName) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(query.toLocaleLowerCase())) ||
                ((_d = (_c = businessUnit.orgName) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === null || _d === void 0 ? void 0 : _d.includes(query.toLocaleLowerCase())));
        }
        return true;
    };
    var assignDefaultOrgBuId = function (bus) {
        return bus.map(function (bu) {
            var defaultOrg = bus.find(function (bus1) { return bus1.orgId === bu.orgId; });
            return __assign(__assign({}, bu), { orgBuId: defaultOrg === null || defaultOrg === void 0 ? void 0 : defaultOrg.buId });
        });
    };
    var assignDefaultOrg = function (bus) {
        var hasDefaultOrg = bus.some(function (bu) { return bu.isDefault; });
        if (hasDefaultOrg) {
            return bus;
        }
        var buWithMatchingName = bus.find(function (bu) { return bu.orgName === bu.buName; });
        return bus.map(function (bu, i) { return (__assign(__assign({}, bu), { isDefault: buWithMatchingName
                ? bu.buId === buWithMatchingName.buId
                : i === 0 })); });
    };
    var businessUnitGroups = pipe(groupByOrganizationWithOrgName, values, map(sortByName), map(assignDefaultOrg), map(sortByIsDefault), map(assignDefaultOrgBuId), flatten, filter(filterByQuery), groupByOrganizationWithOrgName, sortGroupByOrgName, values)(organizations || []);
    return (jsxs(Fragment, { children: [isLoading && jsx(Loading, { label: "loading", isPageLoading: true }, void 0), jsx(Modal, __assign({ isActive: !isLoading && isActive, onClose: onClose }, { children: jsxs(Layout, { children: [jsx(Layout.Row, { children: jsx(Headline, __assign({ size: "huge", isUppercase: false, isGapless: true }, { children: t("change-business-unit") }), void 0) }, void 0), jsx(Layout.Row, { children: jsx(Label, { children: t("select-a-business-unit-to-change") }, void 0) }, void 0), jsx(Layout.Row, { children: jsx(Input, { type: "text", value: query, placeholder: "".concat(t("search"), "..."), icon: "search", onChange: function (e) { return setQuery(e.target.value); } }, void 0) }, void 0), jsx(Layout.Row, { children: jsxs(Layout$1, { children: [jsx(Row, { children: jsx(Column, __assign({ className: styles.header }, { children: t("business-unit") }), void 0) }, void 0), jsx(Row, __assign({ isGapless: true }, { children: jsxs(Menu, __assign({ isFullwidth: true, className: styles.menu }, { children: [businessUnitGroups.map(function (businessUnits) { return (jsx(BusinessunitGroup, { businessUnits: businessUnits, onClick: function () { return setIsLoading(true); } }, businessUnits[0].orgId)); }), businessUnitGroups.length === 0 && (jsx(FlexColumns, { children: jsx(FlexColumn, { children: jsx(Label, { children: t("no-data-to-display") }, void 0) }, void 0) }, void 0))] }), void 0) }), void 0)] }, void 0) }, void 0)] }, void 0) }), void 0)] }, void 0));
};

export { ChangeBusinessUnitModal as default };
